<template>
    <div>
        <div class="pageheader pd-t-25 pd-b-15 row">
            <div class="col-sm-7">
                <div class="pd-t-5 pd-b-5">
                    <h1 class="pd-0 mg-0 tx-20 text-overflow">Transaksi Keluar</h1>
                </div>
                <div class="breadcrumb pd-0 mg-0">
                    <a class="breadcrumb-item" href="#"><i class="fa fa-clipboard mg-r-5"></i>Transaksi Keluar</a>
                    <span class="breadcrumb-item active"> Rusak</span>
                </div>
            </div>
            <div v-if="userdata.role == 'auditor' || userdata.role == 'administrator'" class="col-sm-5">
                Filter SKPD:
                <v-select 
                        :options="listPengguna"
                        :reduce="(label) => label.code"
                        label="label"
                        v-model="filter"
                        @input="handleFilter"
                        ></v-select>
            </div>
        </div> 

        <!-- MAIN CONTENT ================================================== -->
        <!-- <div v-if="userInfo != '4' && userdata.email == '2025'" class="alert alert-danger text-center" role="alert">
            Silahkan periksa dan validasi Saldo Awal anda terlebih dahulu untuk melanjutkan transaksi!
        </div> -->
        <div class="row justify-content-center">
            <div class="col-12 col-lg-12 col-xl-12">
                
                <!-- CONTENT -->
                <div class="tab-content mb-3">
                    <div class="tab-pane show active" id="anggota-tab" role="tabpanel">
                        <div class="card">
                            <div class="card-header">
                                <div class="input-group input-group-flush input-group-merge">
                                    <input type="search" class="form-control form-control-prepended search" v-model="keywords" v-on:keyup.enter="getData()" placeholder="Cari No Bukti/No Dokumen/Tgl Dokumen/Tgl Buku...">
                                    <div class="input-group-prepend">
                                        <div class="input-group-text">
                                            <span class="fe fe-search"></span>
                                        </div>
                                    </div>
                                    <!-- HEADER -->
                                    <button v-if="(userdata.email == '2025' && userdata.parent != 0) || (userdata.email == '2026')" class="btn btn-primary ml-2">
                                        <div class=" d-flex align-items-center">
                                            <router-link :to="{ name:'transaksi_keluar.form_rusak',params: { id: 0 }}">
                                            <i class="text-white fe fe-plus">&nbsp;Tambah Transaksi</i>
                                            </router-link>
                                        </div>
                                    </button>
                                </div>
                            </div>
                            <div class="table-responsive">
                                <table class="m-2 table table-sm table-striped  table-responsive-sm">
                                    <thead>
                                        <tr>
                                            <th style="width:4%">No</th>
                                            <th>No Dokumen</th>
                                            <th>No Bukti</th>
                                            <th>Tgl Dokumen</th>
                                            <th>Tgl Buku</th>
                                            <th>Rupiah</th>
                                            <th>Jenis Anggaran</th>
                                            <th class="text-center" style="width:10%">Aksi</th>
                                        </tr>
                                    </thead>
                                    <tbody v-if="dataTransaksi.length == 0">
                                        <tr>
                                            <td colspan="8">
                                                <div class="alert alert-danger text-center" role="alert">
                                                    Belum Ada Data
                                                </div>
                                            </td>
                                        </tr>
                                    </tbody>
                                    <tbody v-if="!fetching">
                                        <tr v-for="(item, index) in dataTransaksi" :key="index">
                                            <td>{{ (index + 1) + (pagination.currentPage - 1) * pagination.limit }}</td>
                                            <td>{{ item.no_dokumen }}</td>
                                            <td>{{ item.no_bukti }}
                                                <a v-if="item.lampiran && checkDomain == 'persediaanbmd.bandungkab.go.id'" :href="$apiconfig + 'uploads/' + item.lampiran" target="_blank" style="cursor:pointer" class="text-primary"><i class="fa fa-external-link ml-2"></i></a>
                                                <a v-if="item.lampiran && checkDomain != 'persediaanbmd.bandungkab.go.id'" :href="'https://persediaanbmd.bandungkab.go.id/api/uploads/' + item.lampiran" target="_blank" style="cursor:pointer" class="text-primary"><i class="fa fa-external-link ml-2"></i></a>
                                            </td>
                                            <td>{{ item.tgl_dokumen }}</td>
                                            <td>{{ item.tgl_buku }}</td>
                                            <td >Rp. {{ item.rupiah | VMask(currencyMask) }}</td>
                                            <td>{{ item.anggaran }}</td>
                                            <td class="text-right table-actions">
                                                <button v-if="item.request == null && userdata.role == 'dinas'" @click.prevent="postPenghapusan(item.id)" class="btn btn-danger btn-sm mr-2"><i class="fe fe-send mr-2"></i>Ajukan Penghapusan</button>
                                                <button v-if="item.request == 'send' && userdata.role == 'dinas'" disabled class="btn btn-secondary btn-sm mr-2"><i class="fa fa-spin fa-spinner mr-2"></i>Proses Pengajuan Penghapusan</button>
                                                <button v-if="item.request == 'approve' && userdata.role == 'dinas'" disabled class="btn btn-success btn-sm mr-2"><i class="fa fa-check mr-2"></i>Penghapusan Disetujui</button>
                                                <router-link :to="{ name:'transaksi_keluar.form_rusak',params: { id: item.id }}">
                                                <button v-if="item.request != 'approve'" class="btn btn-warning btn-sm mr-2"><i class="fe fe-edit"></i></button>
                                                </router-link>
                                                <button v-if="userdata.parent != 0 && item.request != 'approve'" @click.prevent="postDelete(item.id)" class="btn btn-danger btn-sm mr-2"><i class="fe fe-trash-2"></i></button>
                                                <!-- <button type="button" class="btn btn-secondary btn-sm dropdown-toggle mr-2" data-toggle="dropdown" aria-expanded="false"><i class="fe fe-file"></i></button>
                                                <div class="dropdown-menu dropdown-menu-right" x-placement="bottom-end" style="position: absolute; transform: translate3d(1039px, 118px, 0px); top: 0px; left: 0px; will-change: transform;">
                                                    <a class="dropdown-item tx-13" target="_blank" :href="'https://persediaanbmd.bandungkab.go.id/print/Home/nota_permintaan/' + tokenFix + '/' + item.id + '/' + item.id_user ">📄 Nota Permintaan Barang</a>
                                                    <a class="dropdown-item tx-13" target="_blank" :href="'https://persediaanbmd.bandungkab.go.id/print/Home/surat_permintaan/' + tokenFix + '/' + item.id + '/' + item.id_user ">📄 Surat Permintaan Barang</a>
                                                    <a class="dropdown-item tx-13" target="_blank" :href="'https://persediaanbmd.bandungkab.go.id/print/Home/surat_perintah/' + tokenFix + '/' + item.id + '/' + item.id_user ">📄 Surat Perintah Penyaluran Barang</a>
                                                    <a class="dropdown-item tx-13" target="_blank" :href="'https://persediaanbmd.bandungkab.go.id/print/Home/berita_acara/' + tokenFix + '/' + item.id + '/' + item.id_user ">📄 Berita Acara Serah Terima</a>
                                                </div> -->
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div class="card-footer border-top-0">
                                <div style="float:right">
                                    <!-- <ul class="pagination mb-0"></ul> -->
                                    <v-pagination v-if="pagination.totalPages > 0" v-model="pagination.currentPage"
                                                :page-count="pagination.totalPages"
                                                :classes="pagination.bootstrapPaginationClasses"
                                                :labels="pagination.paginationAnchorTexts"
                                                v-on:change="getData()"></v-pagination>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <!-- ADD SPACE -->
                <br><br><br>
            </div>
        </div>
        <!-- END MAIN CONTENT -->
    </div>
</template>

<script>
    import { mapState } from 'vuex'
    import vPagination from 'vue-plain-pagination'
    import vSelect from "vue-select";
    import "vue-select/dist/vue-select.css";
    import Vue from 'vue'
    import VueMask from 'v-mask'
    Vue.use(VueMask);

    import createNumberMask from 'text-mask-addons/dist/createNumberMask';
    const currencyMask = createNumberMask({
        prefix: '',
        allowDecimal: true,
        decimalLimit: 7,
        includeThousandsSeparator: true,
        allowNegative: false,
    });
    export default {
        metaInfo: {
            title: 'SI',
            titleTemplate: '%s - Data Persediaan'
        },
        data() {
            return {
                baseUrl: this.$apiconfig,
                tokenFix: localStorage.auth_token,
                currencyMask,
                dataTransaksi: [],
                listPengguna: [],
                fetching: true,
                checkDomain: '',
                userInfo: '',
                status: 'rusak',
                form: {
                    id: '',
                    code: '',
                    satuan: '',
                    name: '',
                },
                filter: '',
                pagination: {         
                    currentPage: 1,
                    totalPages: 0,
                    limit: 10,
                    bootstrapPaginationClasses: {
                        ul: 'pagination',
                        li: 'page-item',
                        liActive: 'active',
                        liDisable: 'disabled',
                        button: 'page-link'  
                    },
                    paginationAnchorTexts: {
                        first: '<i class="fe fe-chevrons-left"></i>',
                        prev: '<i class="fe fe-chevron-left"></i>',
                        next: '<i class="fe fe-chevron-right"></i>',
                        last: '<i class="fe fe-chevrons-right"></i>'
                    }
                },
                keywords: '',
                showSelectYear: true
                
            }
        },
        computed: mapState(['userdata']),
        created() {
            this.$store.dispatch('loadUserData');
            this.getData();
            this.getUser();
            this.check_domain();
        },
        mounted() {
            this.checkUser();
        },
        components: {
            vPagination,
            'v-select' : vSelect,
        },
        methods: {
            checkUser() {
                if(this.userdata.role == 'dinas'){
                    this.$http.get(this.baseUrl + 'admin/master/pengguna/info', {
                    params: {
                            parent: this.userdata.id,
                        }
                    })
                        .then((response) => {
                            this.userInfo = response.data.data[0].parent;
                        })
                        .catch((error) => {
                            console.log(error.response.data);
                        }); 
                }
            },
            check_domain() {
                this.checkDomain = window.location.hostname;
            },
            getData() {
                this.fetching = true;
                this.$http.get(this.baseUrl + 'transaksi/keluar', {
                    params: {
                        page : this.pagination.currentPage,
                        keywords: this.keywords,
                        status: this.status,
                        filter: this.filter,
                    }
                })
                    .then((response) => {
                        this.dataTransaksi = response.data.data;
                        this.fetching = false;
                        this.pagination.totalPages = response.data.total_page;
                    })
                    .catch((error) => {
                        console.log(error.response.data);
                        this.fetching = false;
                    });
            },
            getUser() {
                this.fetching = true;
                if(this.userdata.role == 'auditor' || this.userdata.role == 'administrator'){
                    this.$http.get(this.baseUrl + 'admin/master/pengguna/list', {
                    params: {
                            keywords: this.keywords,
                        }
                    })
                        .then((response) => {
                            let data = response.data.data;
                            data.forEach((item) => {
                                this.listPengguna.push({
                                label: item.name,
                                code: item.id,
                                });
                            });
                        })
                        .catch((error) => {
                            console.log(error.response.data);
                        }); 
                }
            },
            handleFilter: function() {
                this.getData();
            },
            postDelete(id) {
                var fd = new FormData()
                fd.append('id', id)
                this.$swal({
                    title: 'Apakah kamu yakin?',
                    html: 'Data yang dihapus tidak dapat di kembalikan',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$http({
                            url: this.baseUrl + 'transaksi/keluar/remove',
                            method: 'post',
                            data: fd
                        }).then((response) => {
                            if(response.data.status){
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                })
                                this.getData();
                            }else{
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: response.data.message,
                                })
                            }
                        }).catch(error => {
                            console.log(error.response.data)
                        })
                    }
                });
            },
            postPenghapusan(id) {
                var fd = new FormData()
                fd.append('id', id)
                this.$swal({
                    title: 'Apakah kamu yakin?',
                    html: 'Data yang dihapus tidak dapat di kembalikan',
                    icon: 'warning',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Yes, delete it!'
                }).then((result) => {
                    if (result.value) {
                        this.$http({
                            url: this.baseUrl + 'transaksi/keluar/request',
                            method: 'post',
                            data: fd
                        }).then((response) => {
                            if(response.data.status){
                                this.$swal({
                                    icon: 'success',
                                    title: 'Success',
                                    text: response.data.message,
                                })
                                this.getData();
                            }else{
                                this.$swal({
                                    icon: 'error',
                                    title: 'Oops...',
                                    text: response.data.message,
                                })
                            }
                        }).catch(error => {
                            console.log(error.response.data)
                        })
                    }
                });
            },
        },
    };
</script>
<style>
    /* style sweetalert */
    .swal2-html-container {
        display: block;
        text-align: center;
    }
</style>